
import React, { useEffect } from "react"
import { Row, Col, Card, CardBody, CardTitle, Badge } from "reactstrap"
import { connect } from "react-redux"
import Miniwidget from "../Miniwidget"
import ReactApexChart from "react-apexcharts"

// Import Action
import { getAdminStats } from "../../../store/actions"

const AdminDashboard = (props) => {
    useEffect(() => {
        props.getAdminStats()
    }, [])

    const { stats, recentActivities, growthData } = props

    const reports = [
        {
            title: "Total Entreprises",
            iconClass: "office-building",
            total: stats?.total_companies?.total || "0",
            average: stats?.total_companies?.growth || "0%",
            badgecolor: "info"
        },
        {
            title: "Abonnements Actifs",
            iconClass: "badge-account-horizontal",
            total: stats?.active_subscriptions?.total || "0",
            average: "Actifs",
            desc: "Abonnements en cours",
            badgecolor: "success"
        },
        {
            title: "Revenu Mensuel",
            iconClass: "cash-multiple",
            total: stats?.monthly_revenue?.total || "0 MAD",
            average: "Ce mois",
            desc: "Paiements reçus",
            badgecolor: "warning"
        },
        {
            title: "Balance TVA à payer",
            iconClass: "calculator-variant",
            total: stats?.total_tva?.total || "0 MAD",
            average: "Total",
            desc: "TVA encaissée",
            badgecolor: "primary"
        },
        {
            title: "Alertes Support",
            iconClass: "help-circle-outline",
            total: stats?.support_tickets?.total || "0",
            average: "Tickets",
            desc: "Demandes totales",
            badgecolor: "danger"
        },
    ]

    const chartOptions = {
        chart: { toolbar: { show: false }, zoom: { enabled: false } },
        colors: ["#7a6fbe"],
        dataLabels: { enabled: false },
        stroke: { curve: "smooth", width: 3 },
        xaxis: { categories: (growthData || []).map(d => d.month) },
        grid: { borderColor: "#f1f1f1" },
    }

    const chartSeries = [
        { name: "Entreprises", data: (growthData || []).map(d => d.count) }
    ]

    return (
        <React.Fragment>
            <Miniwidget reports={reports} />
            <Row>
                <Col xl="8">
                    <Card>
                        <CardBody>
                            <CardTitle className="h4">Croissance du Réseau</CardTitle>
                            <p className="text-muted">Nouvelles inscriptions (6 derniers mois)</p>
                            <div className="mt-4">
                                <ReactApexChart
                                    options={chartOptions}
                                    series={chartSeries}
                                    type="line"
                                    height="300"
                                />
                            </div>
                        </CardBody>
                    </Card>
                </Col>
                <Col xl="4">
                    <Card>
                        <CardBody>
                            <CardTitle className="h4">Flux d'Activités</CardTitle>
                            <div className="p-2 mt-4">
                                <ul className="list-unstyled activity-wid">
                                    {(recentActivities || []).map((activity, i) => (
                                        <li key={i} className="activity-list border-left mb-4">
                                            <div className="activity-icon avatar-xs">
                                                <span className={`avatar-title rounded-circle bg-soft-${activity.color} text-${activity.color}`}>
                                                    <i className={`mdi ${activity.icon}`}></i>
                                                </span>
                                            </div>
                                            <div>
                                                <p className="text-muted mb-1">
                                                    <span className={`text-${activity.color} fw-bold`}>{activity.title}</span> : {activity.description}
                                                </p>
                                                <small className="text-muted">{activity.time}</small>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )
}

const mapStateToProps = state => {
    return {
        stats: state.DashboardAdmin.stats,
        recentActivities: state.DashboardAdmin.recentActivities,
        growthData: state.DashboardAdmin.growthData,
    }
}

export default connect(mapStateToProps, { getAdminStats })(AdminDashboard)
